import { EmployeeAdditionalSkills } from './basicemployeedetails.model';
import { FileToUpload } from './filetoupload';
import { HrEmpAdddressDetails } from './HrEmpAddressDetails';

export class HREmployeeDetails {
  Aadhar: string;
  PAN: string;
  TemporaryAddress: HrEmpAdddressDetails = new HrEmpAdddressDetails();
  PermanentAddress: HrEmpAdddressDetails = new HrEmpAdddressDetails();
  AadharFilePath: string;
  AadharFileName: string;
  PanFilePath: string;
  PanFileName: string;
  Aadharfile: FileToUpload;
  Panfile: FileToUpload;
}

export class Skillset {
  TechGroupId: number;
  TechGroupName: string;
  StreamId: string;
  PrimarySkillId: string;
  employeeAdditionalSkills: EmployeeAdditionalSkills[];
}
